<template>
  <div id="dashboard">
    <HeaderDashboard />
    <div id="dashboard-main">
      <div id="dashboard-leftnav">
        <LeftNavDashboard :property-id="id" />
      </div>
      <div id="dashboard-body">
        <router-view :key="$route.fullPath" />
      </div>
    </div>
  </div>
</template>

<script>
import HeaderDashboard from "@/components/HeaderDashboard.vue";
import LeftNavDashboard from "@/components/LeftNavDashboard.vue";

export default {
  name: "Dashboard",
  components: {
    HeaderDashboard,
    LeftNavDashboard
  },
  data() {
    return {
      id: parseInt(this.$route.params.id)
    };
  }
};
</script>

<style>
#dashboard-main {
  height: 100%;
  width: 100%;
  position: relative;
}
#dashboard-leftnav {
  background: #333232;
  position: absolute;
  width: 60px;
  height: 100%;
  text-align: left;
  padding: 15px;
  font-size: 18px;
  min-height: 1300px;
}
#dashboard-body {
  padding: 20px 20px;
  margin-left: 60px;
  background: #fafafa;
}
</style>
